import { Language } from '../types';

const BASE_LANGUAGE = {
  onbAdd: 'Add',
  onbSaveStk: 'Save',
  onbCompanyDocumentation: 'Company Documentation',
  onbCompanyDocumentationMex: 'General information about your company',
  onbCompanyDocumentationMexTitle:
    "Please upload your company's documents to activate your account",
  onbBankInformation: 'Financial information',
  onbGeneralInformation: 'General Information',
  onbOfficialIdentification: 'Official Identification',
  onbHomeValidation: 'Home Validation',
  onbAboutYourBanking: "About your company's financial institution",
  onbAboutIsYourFirstBank:
    'EFEX will be your first bank account for transactions in the USA?',
  onbUserHaveBankAccount: 'No, I already have a bank account in the USA',
  onbUserDontHaveBankAccount:
    'Yes, EFEX will be my first bank account in the USA',
  onbUserChangeBankOption:
    'I do not have an account in the USA, EFEX will be my first bank account in the USA',
  onbStakeHolders: 'KYC of Shareholders',
  onbTransactionalProfile: 'Additional information',
  onbStakeHoldersTitle: "About your company's shareholders",
  onbFinalQuestions: 'Finally, please answer the following questions:',
  onbDocuments: 'Documents',
  onbFinalQuestions1: 'Purpose of the account?',
  onbFinalQuestions1Placeholder:
    'e.g. Send payments to suppliers in multiple currencies',
  onbFinalQuestions2: 'Tell us about what your company does',
  onbFinalQuestions2Placeholder: 'e.g. Export agricultural products to the US',
  onbFinalQuestions3: 'Which of our products are you interested in using?',
  onbFinalQuestions3Placeholder:
    'Our products: International payments, bulk payments, forwards, collection in USD in the US',
  onbFinalQuestions4: 'Where are your customers located?',
  onbFinalQuestions4Placeholder:
    'e.g. United States, Mexico, Colombia, other countries',
  onbFinalQuestions5: 'Who are your target customers/clients?',
  onbFinalQuestions5Placeholder:
    'e.g. Large fruit and vegetable retailers in the US like Walmart',
  onbFinalQuestions6: 'How do you normally get paid by your customers?',
  onbFinalQuestions6Placeholder:
    'e.g. Domestic wires, ACH, FedNOW, RTP, card, SWIFT, SPEI, SPID, PSE, other payment methods',
  onbPlsEnterYourBankAccount:
    'Please enter your bank account number to connect it with your EFEX account',
  onbAlmostReady: '¡Almost Ready!',
  onbMoreInformationAboutYou:
    'We need to collect data and documents from your company to comply with regulatory requirements. This process is fast and ensures a secure service.',
  onbPlsEnterPersonInformation:
    'Please introduce your information to connect it with your EFEX account',
  onbBankName: 'Name of financial institution',
  onbAccountNumber: 'Account number',
  onbRoutingNumber: 'Routing number / ABA',
  routingNumberAlert: 'The routing number must be for domestic WIRE transfers.',
  onbClabeNumber: 'CLABE Number',
  onbBankStatementThatShows:
    'Bank Statement that shows official company address (please make sure it is less than 3 months old)',
  onbUploadDocument: 'Upload Document',
  onbUpload: 'Upload',
  onbRemove: 'Remove',
  onbPassportExample: 'Example Passport',
  onbDriverLicense: "Example Driver's licence / Personal ID",
  onbConfirmRemove: 'Are you sure you want to remove this record?',
  onbCompanyDocumentationUSA: 'Company Documentation',
  onbCompanyPhoneNumberUSA: 'Company phone number',
  onbCompanyAddressUSA: 'Street / Avenue / Road',
  onbTaxIdUSA: 'Tax ID - Employer Identification Number (EIN)',
  onbTaxIdUSAType: 'Tax ID Type',
  onbTaxIdCOL: 'NIT',
  onbConstitutionDate: 'Incorporation Date',
  onbEinDocument: 'EIN Document',
  onbIncorporationDocumentUSA: 'Incorporation Document of the Company',
  onbIncorporationDocumentMex: 'Incorporation Document of the Company',
  onbFormationCertificate: 'Certificate of training or incorporation',
  onbSatDocumentMex: 'Proof of tax good standing (SAT)',
  onbBankStatement:
    "Financial statement showing your company's official address.",
  onbBankStatementPerson: 'Bank Statement  ',
  onbWebsiteUSA: 'Website',
  onbIncorporation: 'Incorporation date',
  onbBankingInformationUSA: 'Banking Information',
  onbOldDocument: "No older than 3 months and in your company's name.",
  onbDocumentRequired: 'This document is required',
  onbExistence:
    'Certificate of existence and legal representation (Chamber of Commerce)',
  onbStHlName: 'Name(s)',
  onbCompanyName: 'Company name',
  onbStHlLastName: 'Last name',
  onbSsn: 'SSN number (Social Security Number)',
  onbSsnTooltip:
    'This data is protected with the highest levels of security and encryption.',
  onbStHlLastNameSingle: 'Last name',
  onbStHlSecondLastName: 'Second last name',
  onbStHlNameMessage: 'As it appears on your official identification',
  onbStHlBirthDate: 'Date of birth',
  onbStHlCitizenship: 'Country of citizenship',
  onbRegistryCountry: 'Choose country',
  onbStHlPercentage: 'Percentage share in the company',
  onbStHlTitle: 'Charge',
  onbStHlGovId: 'Official government ID',
  onbStHlIdType: 'Document type',
  onbStHlIdNumber: 'Document number',
  onbStHlIdFileFront: 'Official ID (front Photo)',
  onbStHlIdFileBack: 'Official ID (back Photo)',
  onbStHlResidence: 'Main residence address',
  onbStHlResidenceFile: 'Proof of residence',
  onbStHlSectionTitle: 'Stakeholder {{index}}',
  onbStakeAddress1: 'Address line 1',
  onbStakeAddress2: 'Address line 2',
  onbStakeBirthDate: 'Birth Date',
  onbStakeCitizenship: 'Citizen Ship',
  onbStakeCity: 'City',
  onbStakeName: 'Name',
  onbStakeNumberId: 'Number Document',
  onbStakePercentage: 'Percentage',
  onbStakeState: 'State',
  onbStakeTitle: 'Title',
  onbStakeTypeDoc: 'Type Document',
  onbOnlyTextError: 'Enter only text',
  onbOnlyNumberError: 'Enter only numbers',
  onbNitRegexError: 'The NIT consists of 11 digits plus 1 check digit',
  onbRfcError: 'Please enter a valid RFC',
  addressTooLong: 'Address cannot exceed 100 characters',
  addressInvalidCharacters:
    'Address can only contain letters, numbers, and spaces',
  addressStartsWithSpace: 'Address cannot start with a space',
  addressEndsWithSpace: 'Address cannot end with a space',
  addressConsecutiveSpaces: 'Address cannot contain consecutive spaces',
  onbTaxIdUSAError: 'Please enter a valid EIN',
  onbPercentageError: 'Must be maximum 100%',
  onbMaxDigits: 'Must contain {{digits}} digits',
  onbStkCreateError: 'Error creating stakeholder',
  onbAddOneStakeHolder: 'You should add at least one stakeholder',
  onbReviewExamples: 'review examples',
  onbStakeCheck:
    'I certify that I have provided accurate information about myself and anyone with at least a 25% stake in the company.',
  onbSelectAllCountries: 'Select all countries that apply',
  selectAllOptions: 'Select all options that apply',
  onbProduct1: 'International payments',
  onbProduct2: 'Bulk payments',
  onbProduct3: 'Forwards',
  onbProduct4: 'Collection in USD in the US',
  onbProduct5: 'Receive transfers in local currency',
  onbProduct6: 'Business accounts in multiple currencies',
  onbProduct7: 'Embedded integration (SDK)',
  onbProduct8: 'Checkout link',
  paymentOption1: 'Domestic wires',
  paymentOption2: 'ACH',
  paymentOption3: 'FedNOW',
  paymentOption4: 'RTP',
  paymentOption5: 'Card',
  paymentOption6: 'SWIFT',
  paymentOption7: 'SPEI',
  paymentOption8: 'SPID',
  paymentOption9: 'PSE',
  paymentOption10: 'Other payment methods',
  onbNatureOfBusinessQuestion:
    'Does your company operate or have a presence abroad?',
  onbNatureOfBusinessQuestionYesOption: 'Yes',
  onbNatureOfBusinessQuestionNoOption: 'No',
  onbNatureOfBusiness:
    'Business Nature Supporting Documents in the U.S. or abroad.',
  onbNatureOfBusinessSubtitle:
    'Please provide 1 of the following supporting documents to help us verify your business operations:',
  onbNatureOfBusinessOption1:
    'Option 1: Contract for sales that has been signed by the director.',
  onbNatureOfBusinessOption2:
    'Option 2: At least two recent invoice to your customers AND from your suppliers.',
  indivualIdRequirements: 'Official Government ID requirements',
  individualIdLegible: 'Legibility',
  individualIdLegibleMessage:
    'The identification must be clearly visible, without blurriness or shadows that make it difficult to read the information.',
  individualIdComplete: 'Complete Image',
  individualIdCompleteMessage:
    'All identification must be within the image frame, showing all four edges of it.',
  individualIdObstacles: 'Without Obstacles',
  individualIdObstaclesMessage:
    'Avoid holding the identification with visible fingers in the photo, to ensure there are no elements obstructing the view.',
  doYouHaveCompanyOperation: 'Is your company already operating?',
  doYouHaveCompanyOperationDesc:
    'Document that describes the business model in detail.',
  doYouHaveCompanyOperationDownloadTemplate: 'Download template',
  doYouHaveCompanyOperationYesOption: 'Yes',
  doYouHaveCompanyOperationNoOption: 'No',
  operationRequirements: 'Proof of Business Operation',
  operationRequirementsMessage:
    'We require additional information to verify that your company operates in Mexico. Please provide 2 documents from the following:',
  operationRequirementsOption1:
    'Option 1: Brick & Mortar Banking Statement within 3 months (NeoBanks are not considered as valid).',
  operationRequirementsOption2:
    'Option 2: Utility bill dated within 3 months in the name of the company or contracted warehouse (mobile phone bill is not considered as valid).',
  operationRequirementsOption3:
    'Option 3: Contract agreement with the local warehouse or 3rd party logistics service providers.',
  operationRequirementsOption4:
    'Option 4: Employee contract in the registered jurisdiction and 3 months of payslips (minimum of two permanent staff).',
  operationRequirementsOption5:
    'Option 5: Current lease agreement for the company office or the contracted warehouse.',
  operationRequirementsOption6:
    'Option 6: Tax return letter for the past tax year.',
  onbCity: 'City',
  onbState: 'State',
  onbZipCode: 'Zip Code',
  onbCityRequired: 'City is required',
  onbStateRequired: 'State is required',
  onbZipCodeRequired: 'Zip code is required',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE;

const ONBOARDING_USA_LANGUAGE_LABELS: Record<
  Language,
  Record<LabelsLanguage, string | object>
> = {
  EN: BASE_LANGUAGE,
  ES: {
    onbAdd: 'Agregar',
    onbSaveStk: 'Guardar',
    onbCompanyDocumentation: 'Documentación de la Empresa',
    onbCompanyDocumentationMex: 'Datos generales de tu empresa',
    onbCompanyDocumentationMexTitle:
      'Por favor, sube los documentos de tu empresa para activar tu cuenta',
    onbBankInformation: 'Información financiera',
    onbGeneralInformation: 'Información General',
    onbOfficialIdentification: 'Identificación Oficial',
    onbHomeValidation: 'Validación de Domicilio',
    onbAboutYourBanking: 'Sobre la institución financiera de tu empresa',
    onbAboutIsYourFirstBank:
      '¿EFEX será tu primer cuenta bancaria para transacciones en USA?',
    onbUserHaveBankAccount: 'No, ya tengo una cuenta bancaria en USA',
    onbUserDontHaveBankAccount:
      'Sí, EFEX será mi primera cuenta bancaria en USA',
    onbUserChangeBankOption:
      'No tengo cuenta en USA, EFEX será mi primera cuenta bancaria en USA',
    onbStakeHolders: 'KYC de los accionistas',
    onbTransactionalProfile: 'Información adicional',
    onbStakeHoldersTitle: 'Sobre los accionistas de tu empresa',
    onbFinalQuestions: 'Por último, responde a las siguientes preguntas:',
    onbDocuments: 'Documentos',
    onbFinalQuestions1: 'Objetivo de la cuenta:',
    onbFinalQuestions1Placeholder:
      'e.g. Enviar pagos a proveedores en múltiples divisas',
    onbFinalQuestions2: 'Cuéntanos más de la actividad de tu empresa:',
    onbFinalQuestions2Placeholder:
      'e.g. Exportamos productos agrícolas a Estados',
    onbFinalQuestions3: '¿Cuál de nuestros productos te interesa utilizar?',
    onbFinalQuestions3Placeholder:
      'Nuestros productos: pagos internacionales, pagos masivos, futuros/“forwards”/derivados, recaudo en USD en EEUU',
    onbFinalQuestions4: '¿Dónde están ubicados tus clientes?',
    onbFinalQuestions4Placeholder: 'e.g. EEUU, México, Colombia, otros países',
    onbFinalQuestions5: '¿Quiénes son tus clientes objetivo?',
    onbFinalQuestions5Placeholder:
      'e.g. Retailers grandes de frutas y vegetales en EEUU como Walmart',
    onbFinalQuestions6: '¿Cómo normalmente te pagan tus clientes?',
    onbFinalQuestions6Placeholder:
      'e.g. Wires domésticos, ACH, FedNOW, RTP, tarjeta, SWIFT, SPEI, SPID, PSE, otro método',
    onbPlsEnterYourBankAccount:
      'Por favor introduce tu número de cuenta bancaria para conectarla con tu cuenta EFEX',
    onbAlmostReady: '¡Ya casi listo!',
    onbMoreInformationAboutYou:
      'Necesitamos recopilar datos y documentos de tu empresa para cumplir con requisitos regulatorios. Este proceso es rápido y asegura un servicio seguro.',
    onbPlsEnterPersonInformation:
      'Ingresa tú información para conectarla con tu cuenta EFEX',
    onbBankName: 'Nombre de institución financiera',
    onbAccountNumber: 'Número de cuenta',
    onbBankStatementThatShows:
      'Extracto bancario que muestra la dirección oficial de la empresa (asegúrate de que tenga menos de 3 meses de antigüedad)',
    onbUploadDocument: 'Subir Documento',
    onbUpload: 'Subir',
    onbRemove: 'Borrar',
    onbPassportExample: 'Pasaporte de ejemplo',
    onbDriverLicense:
      'Licencia de conducir / Identificación personal de ejemplo',
    onbConfirmRemove: '¿Estás seguro de que quieres borrar este registro?',
    onbRoutingNumber: 'Número routing',
    routingNumberAlert:
      'El número routing debe ser para transferencias WIRE domésticas.',
    onbClabeNumber: 'Número CLABE',
    onbCompanyDocumentationUSA: 'Documentación de la Empresa',
    onbCompanyPhoneNumberUSA: 'Número de teléfono de tu empresa',
    onbCompanyAddressUSA: 'Calle / Avenida / Vía',
    onbTaxIdUSA: 'Tax ID - Employer Identification Number (EIN)',
    onbTaxIdUSAType: 'Tipo de Tax ID',
    onbTaxIdCOL: 'NIT',
    onbConstitutionDate: 'Fecha de constitución',
    onbEinDocument: 'Documento EIN',
    onbIncorporationDocumentUSA: 'Acta constitutiva de la empresa',
    onbIncorporationDocumentMex: 'Escritura constitutiva',
    onbFormationCertificate: 'Certificado de formación o incorporación',
    onbSatDocumentMex: 'Constancia de situación fiscal',
    onbBankStatement:
      'Estado de cuenta financiero que muestre la dirección oficial de tu empresa.',
    onbBankStatementPerson: 'Comprobante bancario.',
    onbWebsiteUSA: 'Website',
    onbIncorporation: 'Fecha de constitución',
    onbBankingInformationUSA: 'Información del Banco',
    onbOldDocument:
      'No mayor a 3 meses de antigüedad y a nombre de tu empresa.',
    onbDocumentRequired: 'Este documento es requerido',
    onbExistence:
      'Certificado de existencia y representación legal (Cámara de Comercio)',
    onbStHlName: 'Nombre(s)',
    onbCompanyName: 'Razón social',
    onbStHlLastName: 'Apellido paterno',
    onbSsn: 'Número SSN (Social Security Number)',
    onbSsnTooltip:
      'Este dato se protege con los más altos niveles de seguridad y encriptación.',
    onbStHlLastNameSingle: 'Apellido',
    onbStHlSecondLastName: 'Apellido materno',
    onbStHlNameMessage: 'Tal como aparece en tu identificación oficial vigente',
    onbStHlBirthDate: 'Fecha de nacimiento',
    onbStHlCitizenship: 'País de ciudadanía',
    onbRegistryCountry: 'Elige el país',
    onbStHlPercentage: 'Participación porcentual en la empresa',
    onbStHlTitle: 'Cargo',
    onbStHlGovId: 'Identificación oficial vigente del gobierno',
    onbStHlIdType: 'Tipo de documento',
    onbStHlIdNumber: 'Número del documento',
    onbStHlIdFileFront: 'Identificación oficial vigente (foto frontal)',
    onbStHlIdFileBack: 'Identificación oficial vigente (foto posterior)',
    onbStHlResidence: 'Dirección de residencia principal',
    onbStHlResidenceFile: 'Comprobante de domicilio',
    onbStHlSectionTitle: 'Accionista {{index}}',
    onbStakeAddress1: 'Dirección 1',
    onbStakeAddress2: 'Dirección 2',
    onbStakeBirthDate: 'Fecha Nacimiento',
    onbStakeCitizenship: 'Ciudadanía',
    onbStakeCity: 'Ciudad',
    onbStakeName: 'Nombres',
    onbStakeNumberId: 'Número de Documento',
    onbStakePercentage: 'Porcentaje',
    onbStakeState: 'Estado',
    onbStakeTitle: 'Título',
    onbStakeTypeDoc: 'Tipo de Documento',
    onbOnlyTextError: 'Introduce solamente texto',
    onbOnlyNumberError: 'Introduce solamente números',
    onbNitRegexError: 'El NIT consta de 11 dígitos mas 1 dígito verificador',
    onbRfcError: 'Por favor introduce un RFC válido',
    addressTooLong: 'La dirección no puede exceder los 100 caracteres',
    addressInvalidCharacters:
      'La dirección solo puede contener letras, números y espacios',
    addressStartsWithSpace: 'La dirección no puede comenzar con un espacio',
    addressEndsWithSpace: 'La dirección no puede terminar con un espacio',
    addressConsecutiveSpaces:
      'La dirección no puede contener espacios consecutivos',
    onbTaxIdUSAError: 'Por favor introduce un EIN válido',
    onbPercentageError: 'Debe ser máximo 100%',
    onbMaxDigits: 'Debe contener {{digits}} dígitos',
    onbStkCreateError: 'Error creando accionista',
    onbAddOneStakeHolder: 'Debes agregar al menos un accionista',
    onbReviewExamples: 'revisa ejemplos',
    onbStakeCheck:
      'Certifico que he proporcionado información precisa sobre mí y cualquier persona con al menos el 25% de participación en la empresa.',
    onbSelectAllCountries: 'Selecciona todos los países que apliquen',
    selectAllOptions: 'Seleccionar todas las opciones que apliquen',
    onbProduct1: 'Pagos internacionales',
    onbProduct2: 'Pagos masivos',
    onbProduct3: 'Futuros/"forwards"/derivados',
    onbProduct4: 'Recaudo en USD en EEUU',
    onbProduct5: 'Recibir transferencias en moneda local',
    onbProduct6: 'Cuentas empresariales en múltiples monedas',
    onbProduct7: 'Integración embebida (SDK)',
    onbProduct8: 'Link de pago',
    paymentOption1: 'Wires domésticos',
    paymentOption2: 'ACH',
    paymentOption3: 'FedNOW',
    paymentOption4: 'RTP',
    paymentOption5: 'Tarjeta',
    paymentOption6: 'SWIFT',
    paymentOption7: 'SPEI',
    paymentOption8: 'SPID',
    paymentOption9: 'PSE',
    paymentOption10: 'Otro método de pago',
    onbNatureOfBusinessQuestion:
      '¿Tu empresa opera o tiene presencia en el extranjero?',
    onbNatureOfBusinessQuestionNoOption: 'No',
    onbNatureOfBusinessQuestionYesOption: 'Sí',
    onbNatureOfBusiness:
      'Documentos de soporte de la naturaleza del negocio en EEUU o en el extranjero.',
    onbNatureOfBusinessSubtitle:
      'Por favor proporciona 1 de los siguientes documentos de soporte para ayudarnos a verificar las operaciones de tu negocio:',
    onbNatureOfBusinessOption1:
      'Opción 1: Contrato de venta firmado por el director.',
    onbNatureOfBusinessOption2:
      'Opción 2: Al menos dos facturas recientes de tus clientes y de tus proveedores.',
    indivualIdRequirements: 'Requisitos de identificación oficial',
    individualIdLegible: 'Legibilidad',
    individualIdLegibleMessage:
      'La identificación debe ser claramente visible, sin borrosidad ni sombras que dificulten la lectura de la información.',
    individualIdComplete: 'Imagen Completa',
    individualIdCompleteMessage:
      'Toda la identificación debe estar dentro del marco de la imagen, mostrando los cuatro bordes de ésta.',
    individualIdObstacles: 'Sin Obstáculos',
    individualIdObstaclesMessage:
      'Evita sostener la identificación con los dedos visibles en la foto, para garantizar que no haya elementos que obstruyan la vista.',
    doYouHaveCompanyOperation: '¿Tu empresa ya está operando?',
    doYouHaveCompanyOperationDesc:
      'Documento que describa detalladamente el modelo de negocio.',
    doYouHaveCompanyOperationDownloadTemplate: 'Descargar plantilla',
    doYouHaveCompanyOperationYesOption: 'Sí',
    doYouHaveCompanyOperationNoOption: 'No',
    operationRequirements: 'Prueba de funcionamiento de la empresa',
    operationRequirementsMessage:
      'Requerimos información adicional para verificar que tu empresa opera en México. Por favor, proporciona 2 documentos de los siguientes:',
    operationRequirementsOption1:
      'Opción 1. Extracto bancario tradicional en un plazo de 3 meses (los Neobancos no se consideran válidos).',
    operationRequirementsOption2:
      'Opción 2. Factura de suministros con fecha inferior a 3 meses a nombre de la empresa o almacén contratado (no se considera como válida la factura del teléfono móvil).',
    operationRequirementsOption3:
      'Opción 3. Acuerdo contractual con el almacén local o proveedores de servicios logísticos externos.',
    operationRequirementsOption4:
      'Opción 4. Contrato de trabajo en la jurisdicción registrada y 3 meses de recibos de sueldo (mínimo dos funcionarios fijos).',
    operationRequirementsOption5:
      'Opción 5. Contrato de arrendamiento vigente de la oficina de la empresa o del almacén contratado.',
    operationRequirementsOption6:
      'Opción 6. Carta de declaración de impuestos del año fiscal anterior.',
    onbCity: 'Ciudad',
    onbState: 'Estado',
    onbZipCode: 'Código Postal',
    onbCityRequired: 'La ciudad es requerida',
    onbStateRequired: 'El estado es requerido',
    onbZipCodeRequired: 'El código postal es requerido',
  },
};

export default ONBOARDING_USA_LANGUAGE_LABELS;
